import InstantInput from "@/components/form/InstantInput"
import { ChangeBuilder } from "@/modifications"
import { Instant } from "@/Temporal"
import type { InputHTMLAttributes } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../IncidentLogHandler"
import { useIncidentValue } from "../inputHelpers"

interface Props {
	path: ChangeBuilder<Instant>
	min?: Instant
	max?: Instant
}

const IncidentInstantInput: ReactiveComponent<Props, InputHTMLAttributes> = (props, { attrs }) => {
	const handler = useIncidentHandler()
	const existingValue = useIncidentValue(props.path)

	function saveChanges(instant: Instant) {
		handler.submitChange(props.path.setTo(instant))
	}

	return () => (
		<InstantInput
			value={existingValue.value}
			setValue={saveChanges}
			min={props.min}
			max={props.max}
			{...attrs}
			required
		/>
	)
}

export default defineComponent(IncidentInstantInput, inferProps<Props>())
